interface BarChartProps {
  data: { label: string; value: number }[];
  color?: string;
  valuePrefix?: string;
  valueSuffix?: string;
  height?: number;
}

export default function BarChart({
  data,
  color = "#00AAB7",
  valuePrefix = "",
  valueSuffix = "",
  height = 220,
}: BarChartProps) {
  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="flex w-full items-end gap-2" style={{ height }}>
      {data.map((d, i) => (
        <div key={i} className="group flex h-full flex-1 flex-col items-center justify-end gap-2">
          <div className="relative flex w-full flex-1 items-end justify-center">
            <div
              className="relative w-full max-w-[42px] cursor-pointer rounded-t-lg transition-opacity group-hover:opacity-90"
              style={{
                height: `${Math.max((d.value / max) * 100, 4)}%`,
                background: `linear-gradient(to top, ${color}, ${color}CC)`,
              }}
            >
              <div className="pointer-events-none absolute -top-9 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-lg bg-[#007A85] px-2 py-1 text-[11px] font-medium text-white opacity-0 shadow-card transition-opacity group-hover:opacity-100">
                {valuePrefix}
                {d.value.toLocaleString("en-US")}
                {valueSuffix}
              </div>
            </div>
          </div>
          <span className="whitespace-nowrap text-[11px] text-ghasla-text-secondary">{d.label}</span>
        </div>
      ))}
    </div>
  );
}